import { useTranslation } from "react-i18next"

import { useCacheContext } from "./cache-context"

export function CacheInfoDisplay() {
  const { t } = useTranslation()
  const { cacheTimestamp } = useCacheContext()

  if (!cacheTimestamp) {
    return null
  }

  return (
    <div className="text-sm text-neutral-500">
      {t("performance.table.cacheTips", { time: cacheTimestamp })}
    </div>
  )
}
